import React from "react";

import { InputPicker } from "rsuite";
import MinusIcon from "@rsuite/icons/Minus";

const RespForm = ({
    lowVery,
    lowWarnOptions,
    lowErrorvery_low_warn_alert_time,
    handleResetDefaultRespiration,
    highErrorvery_high_urgent_alert_time,
    highErrorvery_high_warn_alert_time,
    rrWarningTimerOptions,
    rrUrgentTimerOptions,
    normal,
    handleChange,
    lowErrorvery_low_urgent_alert_time,
    lowWarn }) => {

    const optionsBelowNormal = lowWarnOptions.filter(item => item.value < normal)
    const lowWarnOptionsData = optionsBelowNormal.length ? optionsBelowNormal : lowWarnOptions;
    const normalWarnOptionsData = lowVery ? lowWarnOptions.filter(item => item.value > lowVery) : lowWarnOptions;

    return (
        <div className="rr-settings">
            <div className="card">
                <div className="card-header">
                    Respiration Range
                </div>
                <section className="instructions">
                    Set the ranges for Respiration. Please note that you may need to go back and adjust other levels if you make a change.
                </section>
                <div className="card-body">
                    <div className="rr-setting-box">
                        <div className="row">
                            <div className="col-md-5 col-xs-12 rr-box">
                                <div className="row">
                                    <div className="col-md-5">
                                        <label className="d-flex align-items-center justify-content-center">
                                            <div>
                                                Low
                                            </div>
                                        </label>
                                        <div className="d-flex align-items-center justify-content-center">
                                            <strong>0</strong>&nbsp;RR
                                            <MinusIcon style={{ margin: "0px 5px" }} />

                                            <InputPicker data={lowWarnOptionsData}
                                                placeholder={"Select visit Timer"}
                                                className="settings-group"
                                                onChange={(value) => handleChange("setting.rr.low", value)}
                                                value={lowVery}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-7">
                                        <label className="d-flex align-items-center justify-content-center">
                                            <div>
                                                Alerts
                                            </div>
                                        </label>
                                        <div className="row">
                                            <div className="col-md-4 d-flex align-items-center justify-content-end">
                                                <div className="form-group">
                                                    Warning
                                                </div>
                                            </div>
                                            <div className="col-md-8">
                                                <div className="form-group">
                                                    <InputPicker data={rrWarningTimerOptions}
                                                        placeholder={"Select visit Timer"}
                                                        className="settings-group"
                                                        onChange={(value) => handleChange("setting.rr.low_warn_alert_time", value)}
                                                        value={lowErrorvery_low_warn_alert_time}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 d-flex align-items-center justify-content-end">
                                                <div className="form-group">
                                                    Urgent
                                                </div>
                                            </div>
                                            <div className="col-md-8">
                                                <div className="form-group">

                                                    <InputPicker data={rrUrgentTimerOptions}
                                                        placeholder={"Select"}
                                                        className="settings-group"
                                                        onChange={(value) => handleChange("setting.rr.low_urgent_alert_time", value)}
                                                        value={lowErrorvery_low_urgent_alert_time}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-2 col-xs-12 rr-box brl" >
                                <label className="d-flex align-items-center justify-content-center" >
                                    <div>
                                        Normal
                                    </div>
                                </label>
                                <div className="d-flex align-items-center justify-content-between">
                                    <strong>{lowWarn ? lowWarn + 1 : lowVery + 1}</strong>&nbsp;RR
                                    < MinusIcon style={{ margin: "0px 5px" }} />
                                    <InputPicker data={normalWarnOptionsData}
                                        className="settings-group"
                                        placeholder={"Select visit Timer"}
                                        onChange={(value) => handleChange("setting.rr.normal", value)}
                                        value={normal}
                                    />
                                </div>
                            </div>
                            <div className="col-md-5 col-xs-12 rr-box">
                                <div className="row">
                                    <div className="col-md-5">
                                        <label className="d-flex align-items-center justify-content-center">
                                            <div>
                                                High
                                            </div>
                                        </label>
                                        <div className="d-flex align-items-center justify-content-center">
                                            <strong>{normal ? parseInt(normal, 10) + 1 : lowVery + 1}</strong>&nbsp; RR &nbsp;
                                            <strong>and over</strong>
                                        </div>
                                    </div>
                                    <div className="col-md-7">
                                        <label className="d-flex align-items-center justify-content-center">
                                            <div>
                                                Alerts
                                            </div>
                                        </label>
                                        <div className="row">
                                            <div className="col-md-4 d-flex align-items-center justify-content-end">
                                                <div className="form-group">
                                                    Warning
                                                </div>
                                            </div>
                                            <div className="col-md-8">
                                                <div className="form-group">
                                                    <InputPicker data={rrWarningTimerOptions}
                                                        placeholder={"Select visit Timer"}
                                                        className="settings-group"
                                                        onChange={(value) => handleChange("setting.rr.high_warn_alert_time", value)}
                                                        value={highErrorvery_high_warn_alert_time}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 d-flex align-items-center justify-content-end">
                                                <div className="form-group">
                                                    Urgent
                                                </div>
                                            </div>
                                            <div className="col-md-8">
                                                <div className="form-group">
                                                    <InputPicker data={rrUrgentTimerOptions}
                                                        placeholder={"Select"}
                                                        className="settings-group"
                                                        onChange={(value) => handleChange("setting.rr.high_urgent_alert_time", value)}
                                                        value={highErrorvery_high_urgent_alert_time}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-footer text-right">
                    <button className="btn btn-secondary" onClick={handleResetDefaultRespiration}>Return to Default</button>
                </div>
            </div>
        </div>
    );

}

RespForm.defaultProps = {
    lowVery: null,
    lowWarnOptions: null,
    lowErrorvery_low_warn_alert_time: null,
    highErrorvery_high_urgent_alert_time: null,
    highErrorvery_high_warn_alert_time: null,
    rrWarningTimerOptions: null,
    rrUrgentTimerOptions: null,
    normal: null,
    lowErrorvery_low_urgent_alert_time: null,
    lowWarn: null
}

export default RespForm;

